import { DEFAULT_LIMIT_AMT } from '../../constants/account-information';
import { baseReducer } from '../../store/core/base-reducer';
import { APP_INITIALIZATION } from '../core/base-actions';
import { GET_ACCOUNT_INFORMATION_SUCCESS } from './account-information.actions';

// TODO think about if we actually _want_ initial state since null is valid and meaningful
const initialState = {
  limitRemaining: Number.MAX_VALUE,
  trustLevel: 'Trusted',
  limit: DEFAULT_LIMIT_AMT,
  // isVerificationRequested: false,
  // isWalletCreatedAfterAPLaunch: false,
  surchargeEnrollmentStatus: 'NotSet',
};

const actionHandlerMap = {
  [APP_INITIALIZATION]: (state, { initialData }) => {
    if (initialData.seller.homeCountry !== 'US') {
      return initialState;
    }
    return {
      ...state,
      ...(initialData.accountData || initialState),
    };
  },
  [GET_ACCOUNT_INFORMATION_SUCCESS]: (state, { accountInformation = {} }) => ({
    ...state,
    ...accountInformation,
  }),
};

export const ConnectedActionHandlerMap = baseReducer(initialState, actionHandlerMap);

export { namespace } from './account-information.reducer.metadata';
